import React, { useCallback, useState } from 'react';
import { IDocumentInformation } from './UploadDocumentContainer';
import { useDropzone } from 'react-dropzone';
import { AddDocumentModal } from '../../../../../pages/order/documentsPortal/AddDocumentModal';
import { IUploadDocument } from '../../../../../types/order/documents/upload/interfaces';
import { IDocumentCategory } from 'types/order/documents/IDocumentCategoryType';
import ReactDOM from 'react-dom';

interface IDragAndDropContainerProps {
  onUploadDocuments: (documents: IUploadDocument[]) => Promise<any>;
  orderId: string;
  setShowAddDocumentModal: (show: boolean) => void;
  showAddDocumentModal: boolean;
  standardDocumentCategories: IDocumentCategory[];
  renderTargetId?: string;
  children: React.ReactNode;
}

export const DragAndDropContainer: React.FC<IDragAndDropContainerProps> = ({
  children,
  onUploadDocuments,
  orderId,
  setShowAddDocumentModal,
  showAddDocumentModal,
  standardDocumentCategories,
  renderTargetId,
}) => {
  const [uploadedDocuments, setUploadedDocuments] = useState<IDocumentInformation[]>([]);

  const onDrop = useCallback(
    (files: File[]) => {
      const newDocuments = files.map((file) => {
        return { file: file, category: null, done: false };
      });
      setUploadedDocuments([...newDocuments, ...uploadedDocuments]);
      setShowAddDocumentModal(true);
    },
    [uploadedDocuments, setShowAddDocumentModal]
  );
  const { getRootProps, getInputProps } = useDropzone({ onDrop, multiple: true, noClick: true });
  const renderTarget = renderTargetId && document.getElementById(renderTargetId);
  return (
    <div>
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        {children}
      </div>
      {!renderTarget && showAddDocumentModal && (
        <AddDocumentModal
          onClose={() => {
            setShowAddDocumentModal(false);
            setUploadedDocuments([]);
          }}
          onDrop={onDrop}
          onUploadDocuments={onUploadDocuments}
          orderId={orderId}
          uploadedDocuments={uploadedDocuments}
          setUploadedDocuments={setUploadedDocuments}
          categories={standardDocumentCategories}
        />
      )}
      {renderTarget &&
        showAddDocumentModal &&
        ReactDOM.createPortal(
          <AddDocumentModal
            onClose={() => {
              setShowAddDocumentModal(false);
              setUploadedDocuments([]);
            }}
            onDrop={onDrop}
            onUploadDocuments={onUploadDocuments}
            orderId={orderId}
            uploadedDocuments={uploadedDocuments}
            setUploadedDocuments={setUploadedDocuments}
            categories={standardDocumentCategories}
          />,
          renderTarget
        )}
    </div>
  );
};
